
import { lopActions } from "./lopActions";
import { ngayNghiActions } from "./ngayNghiAction";

export const danhMucActionsWrapper = {
    lop: lopActions,
 ngayNghi: ngayNghiActions   
}